import { readOnly, sort } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { task } from "ember-concurrency";

/**
 * Manage the state of the Activity Feed.
 */
const ActivityFeedStateManagerHybrid = Service.extend({
  /**
   * @type {Ember.Service}
   */
  applicationState: service('states/application'),
  applicationStateManager: service('state-managers/application'),
  session: service(),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * The current list of the most recent activity feed items
   *
   * @type {Ember.MutableArray}
   */
  recentActivityFeedItems: readOnly('applicationState.mostRecentActivityFeedItems'),

  /**
   * @type {Array.<string>}
   */
  sortingDescription: ['createdAt:desc'],

  /**
   * Sorted decending by the createdAt date
   *
   * @type {Ember.MutableArray}
   */
  sortedRecentActivityFeedItems: sort('recentActivityFeedItems', 'sortingDescription'),

  /**
   * Public function to update the activity feed.
   */
  updateActivityFeedItems: function() {
    this.get('_updateFeed').perform();
  },

  /**
   * Makes the actual api call and updates the internal model.
   *
   * @private
   */
  _updateFeed: task(function *() {
    let feedPromise = this.get('store').query('activity-feed-item', {
      adapterOptions: {
        pathPrefixModelIdPairs: [`user:${this.get('currentUser').get('id')}`]
      }
    });

    let activityFeedItems = yield feedPromise;
    this.get('applicationStateManager').updateRecentActivityFeedItems(activityFeedItems);
  }),
});

export default ActivityFeedStateManagerHybrid;
